import {config} from '@/config/config';
import store from '@/store';

function SFAnalytics() {
    var self = this;

    var initSegment = function () {
        return new Promise(function (resolve) {
            var analytics = window.analytics = window.analytics || [];
            if (!analytics.initialize) {
                if (analytics.invoked) {
                    resolve();
                    window.console && console.error && console.error("Segment snippet included twice.");
                } else {
                    analytics.invoked = !0;
                    analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];
                    analytics.factory = function (e) {
                        return function () {
                            var t = Array.prototype.slice.call(arguments);
                            t.unshift(e);
                            analytics.push(t);
                            return analytics
                        }
                    };
                    for (var e = 0; e < analytics.methods.length; e++) {
                        var key = analytics.methods[e];
                        analytics[key] = analytics.factory(key)
                    }
                    analytics.load = function (key, e) {
                        var t = document.createElement("script");
                        t.type = "text/javascript";
                        t.async = !0;
                        t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
                        var n = document.getElementsByTagName("script")[0];
                        n.parentNode.insertBefore(t, n);
                        analytics._loadOptions = e
                        t.onload = function () {
                            resolve();
                        }
                    };
                    analytics.SNIPPET_VERSION = "4.13.1";
                    analytics.load(config('SEGMENT_KEY'));
                    // analytics.page();
                }
            } else {
                resolve();
            }
        })
    }


    self.track = function (name, props) {
        let props_copy = {...props};
        initSegment().then(() => {
            if (store.state.user.isLoggedIn) {
                props_copy['email'] = store.state.user.info.user.email;
            }
            window.analytics.track(name, props_copy);
        })
    };


    self.identify = function (userId, props) {
        initSegment().then(() => {
            window.analytics.identify(userId, props, {
                integrations: {
                    'All': false,
                    'HubSpot': true,
                    'Intercom': true,
                    'Mixpanel': true,
                    "Customer.io": true,
                }
            });
            window._loq = window._loq || []
            window._loq.push(['custom', props]);
        });
    };


    self.page = function (name, props = {}) {
        let props_copy = {...props};

        if (store.state.user.isLoggedIn) {
            props_copy['email'] = store.state.user.info.user.email;
        }

        initSegment().then(() => {
            window.analytics.page('app', name, props_copy, {
               integrations: {
                    'All': true,
                    'Intercom': false,
                }
            });
        });
    };
}

if(config('DISABLE_ANALYTICS') === true){
    window.SFAnalytics = {
        'page': ()=>{},
        'identify': ()=>{},
        'track': ()=>{},
    };
}
else {
    window.SFAnalytics = new SFAnalytics();
}

